import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const container = css`
  position: relative;
  display: inline-block;
  vertical-align: middle;

  &:hover .dropdown,
  .dropdown:hover {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
    z-index: 1;
  }
`

export const hidden = css`
  display: none;
`

export const link = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${theme.palette.primary.mainContrast};
  cursor: pointer;

  span {
    font-weight: 500;
  }

  ${breakpoint.up('lg')} {
    cursor: inherit;
    display: inline;
    position: relative;
    padding: 15px 0;

    span {
      display: inline;
    }
  }
`

export const inverted = (theme: Theme) => css`
  ${breakpoint.up('lg')} {
    color: ${theme.palette.background.main};
  }
`

export const full = (theme: Theme) => css`
  ${breakpoint.up('lg')} {
    padding-bottom: ${size[40]};
    margin-bottom: ${size[20]};

    &:hover::before {
      content: '';
      height: 3px;
      background: ${theme.palette.primary.mainContrast};
      width: ${size[90]};
      display: block;
      position: absolute;
      border-radius: 0 0 6px 6px;
      z-index: 10;
      bottom: 5px;
      left: 0;
    }
  }
`

export const icon = (theme: Theme) => css`
  fill: ${theme.palette.primary.mainContrast};

  ${breakpoint.up('lg')} {
    min-width: ${size[12]};
    margin: 0 0 0 ${size[8]};
  }
`
